import { Component, inject, signal } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { SafePipe } from '../../pipes/safe.pipe';
import { Modal } from '../../services/modal.service';

@Component({
  selector: 'modal-message',
  imports: [TranslatePipe, SafePipe],
  templateUrl: './message.component.html',
  styleUrls: ['./message.component.scss']
})
export class MessageComponent {

  private modal = inject(Modal);
  message = signal<string>('');

  close() {
    this.modal.dismiss();
  }
}
